import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

const Catalog = () => {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16" data-testid="catalog-page">
      <div className="mb-12">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-sky-600 mb-3">Catalogo completo</p>
        <h1 className="font-heading text-5xl tracking-tight font-light text-[#032B44]">I nostri prodotti</h1>
        <p className="text-slate-600 mt-4 max-w-xl">Scegli la forma di ghiaccio adatta alla tua attività. I clienti partner vedono i prezzi personalizzati dopo l'accesso.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {products.map((p) => <ProductCard key={p.product_id} product={p} />)}
      </div>
    </div>
  );
};

export default Catalog;
